export class FilterFaqs {
    handle() {
        //search the elements with class collapsible__accordion-title, from each element search if they have a | in their innerHTML and if they have it, split the string by |
        const elements = document.querySelectorAll('.collapsible__heading');
        //capture the url params pickCountry and dropCountry
        const urlParams = new URLSearchParams(window.location.search);
        const pickCountry = urlParams.get('pickCountry') != undefined ? urlParams.get('pickCountry') || "US" : urlParams.get('dropCountry') || 'US';
        const dropCountry = urlParams.get('dropCountry') != undefined ? urlParams.get('dropCountry') || "US" : urlParams.get('pickCountry') || 'US';
        sessionStorage.setItem('pickCountry', pickCountry);
        sessionStorage.setItem('dropCountry', dropCountry);
        let visible = 0;
        elements.forEach((element) => {
            const text = element.innerHTML;
            const parts = text.split('|');
            const parentElement = element.closest('.collapsible');
            //set the element onnerHTML to the first part of the string
            element.innerHTML = parts[0].trim();
            //check if the second part of the string is equal to the country
            if (parts.length > 1) {
                const countryPart = parts[1].trim();
                //if country and countryPart are "GB" show the element and hide the elements with countryPart "US", if the country is != "GB" hide the eleemnts with countryPart "GB"
                if (countryPart == pickCountry && visible == 0 || countryPart == dropCountry && visible == 0) {
                    if (parentElement) {
                        parentElement.style.display = 'block';
                        visible++;
                    }
                }
                else {
                    if (parentElement) {
                        parentElement.style.display = 'none';
                    }
                }
            }
        });
    }
}
